export default __webpack_public_path__ + "static/logo-9d6e2fdb145d7bdf9aee414d66a5a2c9.svg";